import { isAuthenticated } from 'modules/common/permissions';

import VectorFileEditorPage from '../entry';
import { initVectorFileEditor } from './sagas';

export default [
  {
    component: VectorFileEditorPage,
    exact: true,
    path: '/vectorFileEditor/:mode/:activeId/',
    permissions: [isAuthenticated],
    saga: initVectorFileEditor,
  },
];
